/**
 * TODO [IndexTable]
 * 1. extend IndexTable to Table
 * 2. the new Table should use below slots
 *    - containerComponent
 *    - tableComponent
 *    - bodyComponent
 *    - rowComponent
 *
 * e.g rowComponent can be set HoverableRow
 *
 * Ref: how the HoverableRow component was used in HoverableTable component
 */

import { useState, useEffect } from 'react';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import { IndexTableToolbar } from './IndexTableToolbar';
import { IndexTableContainer } from './IndexTableContainer';
import { Loading } from '../Loading';
import { Container, TableCellProps, Typography } from '@mui/material';
import { CheckboxFilter } from './filters/TableCheckboxFilter';
import { TextFilter } from './filters/TableTextFilter';
import {
  initCheckboxFilters,
  initTextFilters,
  getTextFilteredData,
  getCheckboxFilteredData,
  getComparator,
} from '../../utils/table.util';
import {
  IndexTableContext,
  IndexTableContextContent,
  IndexTableProps,
  IndexTableProvider,
  RowCell,
} from './index_table.context';

export const IndexTable = (props: IndexTableProps) => {
  return (
    <IndexTableProvider {...props}>
      <IndexTableContext.Consumer>
        {contextProps => <IndexTableComponent {...props} {...contextProps} />}
      </IndexTableContext.Consumer>
    </IndexTableProvider>
  );
};

const IndexTableComponent = (props: IndexTableContextContent) => {
  const {
    checkboxes,
    expandOnCheckbox,
    icons,
    iconHead,
    isLoading,
    visible,
    onRowClick,
    defaultOrder,
    defaultOrderBy,
    toolbar,
    hoverCell,
    exportFormat,
    //NEED TO REMOVE CAUSING LOOP OF RENDERS
    selected = [],
    setSelected = () => {},
    //////
    selectMultiple,
    pagination,
    itemBorder,
    rowBorder,
    headCells,
    rows,
    title,
    handleRequestSort,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSelectAllClick,
    clearFilters,
    updateCheckboxFilters,
    selectAllCheckboxFilters,
    unselectAllCheckboxFilters,
    updateTextFilters,
    definedRowsPerPageOptions,
    emptyRows,
    page,
    setPage,
    setDefaultCheckboxFilters,
    setDefaultTextFilters,
    setCheckboxFilters,
    setTextFilters,
    textFilters,
    checkboxFilters,
    filteredData,
    setFilteredData,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    rowsPerPage = 25,
    setRowsPerPage,
    defaultCheckboxFilters,
  } = props;
  //local effects
  /*****************************************************************/
  useEffect(() => setPage(0), [rows]);

  useEffect(() => {
    if (rows && headCells) {
      setSelected([
        ...selected.filter(id =>
          rows.map((row: RowCell) => row.id).includes(id)
        ),
      ]);
      const defaultCheckboxFilters = initCheckboxFilters(rows, headCells);
      const defaultTextFilters = initTextFilters(headCells);

      setDefaultCheckboxFilters(
        JSON.parse(JSON.stringify(defaultCheckboxFilters))
      );
      setDefaultTextFilters(JSON.parse(JSON.stringify(defaultTextFilters)));

      setCheckboxFilters(JSON.parse(JSON.stringify(defaultCheckboxFilters)));
      setTextFilters(JSON.parse(JSON.stringify(defaultTextFilters)));
    }
  }, [rows, headCells]); // eslint-disable-line

  useEffect(() => {
    if (rows && textFilters && checkboxFilters) {
      let filteredData = [...getTextFilteredData(rows, textFilters)];
      filteredData = [
        ...getCheckboxFilteredData(filteredData, checkboxFilters),
      ];
      setFilteredData(filteredData);
    }
  }, [checkboxFilters, textFilters, rows]); // eslint-disable-line

  useEffect(() => {
    if (rows && textFilters && checkboxFilters) {
      let filteredData = [...getTextFilteredData(rows, textFilters)];
      filteredData = [
        ...getCheckboxFilteredData(filteredData, checkboxFilters),
      ];
      setFilteredData(filteredData);
    }
  }, [checkboxFilters, textFilters, rows]); // eslint-disable-line

  return (
    <Paper id={'index-table'} elevation={0} sx={{ position: 'relative' }}>
      {isLoading ? (
        <Container sx={{ minHeight: '300px' }}>
          <Loading text={`Loading ${title}`} size={18} />
        </Container>
      ) : (
        <>
          {toolbar ? (
            <IndexTableToolbar
              numSelected={selected.length}
              title={title || ''}
              total={rows.length}
            />
          ) : (
            title != '' && <Typography variant={'overline'}>{title}</Typography>
          )}
          <IndexTableContainer />
          {pagination && (
            <TablePagination
              rowsPerPageOptions={[
                { label: '10', value: 10 },
                { label: '25', value: 25 },
                { label: '50', value: 50 },
                { label: 'All', value: 10000 },
              ]} //value -1 not working!
              component="div"
              count={rows?.length || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ minHeight: '75px' }}
            />
          )}
        </>
      )}
    </Paper>
  );
};
